import { dbFieldTypeMap } from '@databases/collab/convert/to-collab';
import { DEFAULT_ENTRY_ID } from '@databases/types/database';
import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types';
import { applyDeltaValue } from '../../utils/apply-delta-value';
import { getConvertedValue } from '../../utils/get-converted-value';
import { getOrSetValue } from '../../utils/get-or-set-value';

export const setValue: YJSChangeHandler<DatabaseChangeType.SET_VALUE> = ({
  ydb,
  change,
  state
}) => {
  const delta = change.change;

  if (!delta) {
    return;
  }

  const destType = dbFieldTypeMap[delta.type];

  if (!destType) {
    throw new Error('unsupported type ' + destType);
  }

  const convertedValue = getConvertedValue(
    ydb,
    change.fieldId,
    (change.entryId === DEFAULT_ENTRY_ID
      ? ydb.defaultEntry
      : ydb.entriesById[change.entryId]
    ).getValue(change.fieldId),
    destType,
    state
  );

  ydb.mutate((db) => {
    const entry =
      change.entryId === DEFAULT_ENTRY_ID
        ? db.defaultEntry
        : db.entriesById[change.entryId];

    const field = db.fieldsById[change.fieldId];

    if (!entry || !field) {
      return;
    }

    applyDeltaValue(
      (destType) => getOrSetValue(entry, change.fieldId, destType, convertedValue),
      delta
    );
  });
};
